enum PersonalTournamentSubscriptionStatusEnum {
    NONE= 0,
    NOT_SUBSCRIBED_YET = 1,
    SUBSCRIBED = 2
}

export default PersonalTournamentSubscriptionStatusEnum;